import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';
import { FamilyPlanMemberType } from '../family-plan.model';

export class masterAddressUpdateDialogAction implements Action {
  constructor(
    public address: any,
    public type:FamilyPlanMemberType
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/master-address-update-dialog/master-address-update-dialog.action.ts